import PropTypes from 'prop-types';
import { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
// @ts-expect-error untyped dependency
import { getId } from 'dashboard-lib/public/report/report-schema';
// @ts-expect-error untyped dependency
import { selectHasIframeWidgetAccess } from 'dashboard-lib/public/userInfo/scopes';
// @ts-expect-error untyped dependency
import ViewReportErrorWrapper from 'dashboard-components/error/ViewReportErrorWrapper';
import { getIframeBody, IframeLoadingStatus } from 'platform-dashboard-ui/lib/iframe/iframeHelpers';
import { isHubSpotContent } from 'platform-dashboard-ui/lib/iframe/getIframeContentProvider';
import { DashboardIframeEmbed } from 'platform-dashboard-ui/components/widget/iFrameWidget/DashboardIframeEmbed';
import { useWidgetContext } from './WidgetContext';
// @ts-expect-error untyped dependency
import { refreshReportSuccess } from '../../actions/DashboardActions';
// @ts-expect-error untyped dependency
import { getId as getDashboardId } from 'dashboard-lib/public/dashboard/dashboard-schema';
// @ts-expect-error untyped dependency
import { getId as getReportId } from 'dashboard-lib/public/report/report-schema';
// @ts-expect-error untyped dependency
import { selectForceRenderCount } from '../../ducks/forceRenderCount';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const WidgetBodyContainer = styled.div.withConfig({
  displayName: "IframeWidgetBody__WidgetBodyContainer",
  componentId: "sc-122u5cf-0"
})(["height:100%;width:100%;overflow:auto;"]);
const IframeWidgetBody = ({
  reportRefreshCount
}) => {
  const {
    dashboard,
    report
  } = useWidgetContext();
  const iframeBody = getIframeBody(report.getIn(['config', 'content']));
  const isHubSpotEmbed = useMemo(() => isHubSpotContent(iframeBody), [iframeBody]);
  const hasIframeWidgetAccess = useSelector(selectHasIframeWidgetAccess);
  const [loadingStatus, setLoadingStatus] = useState(isHubSpotEmbed ? IframeLoadingStatus.COMPLETE : IframeLoadingStatus.LOADING);
  const [widgetRenderCount, setWidgetRenderCount] = useState(1);
  const dashboardRefreshCount = useSelector(selectForceRenderCount);
  useEffect(() => {
    if (!isHubSpotEmbed) {
      setLoadingStatus(IframeLoadingStatus.LOADING);
    }
    setWidgetRenderCount(widgetRenderCount + 1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reportRefreshCount, dashboardRefreshCount, isHubSpotEmbed]);
  useEffect(() => {
    const timer = setTimeout(() => {
      if (loadingStatus === IframeLoadingStatus.LOADING) {
        refreshReportSuccess({
          dashboardId: getDashboardId(dashboard),
          reportId: getReportId(report)
        });
      }
    }, 20000);
    return () => clearTimeout(timer);
  }, [loadingStatus, dashboard, report]);
  if (!hasIframeWidgetAccess) {
    return /*#__PURE__*/_jsx(ViewReportErrorWrapper, {
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "iframeWidget.accessDenied.title"
      }),
      children: /*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "iframeWidget.accessDenied.body"
        })
      })
    });
  }
  return /*#__PURE__*/_jsxs(WidgetBodyContainer, {
    "data-test-id": loadingStatus === IframeLoadingStatus.COMPLETE && 'iframe-loaded',
    children: [loadingStatus === IframeLoadingStatus.LOADING && /*#__PURE__*/_jsx(UILoadingSpinner, {
      grow: true
    }), /*#__PURE__*/_jsx(DashboardIframeEmbed, {
      html: iframeBody,
      onSetContentDone: () => {
        setLoadingStatus(IframeLoadingStatus.COMPLETE);
      },
      reportId: getId(report)
    }, widgetRenderCount)]
  });
};
IframeWidgetBody.propTypes = {
  reportRefreshCount: PropTypes.number
};
export default IframeWidgetBody;